import styled from "styled-components";

export const FormWrapper = styled.div`
    padding: clamp(20px, 1.25vw, 24px) clamp(16px, 1.25vw, 24px);
    background: #FFFFFF;
    border: 1.5px solid rgba(211, 211, 211, 0.5);
    border-radius: 15px;
    max-height: calc(100vh - clamp(187px,10.417vw,200px));
    overflow: auto;
    display: flex;
    flex-direction: column;
    /* gap: 30px; */    
    .request-order-upload-section {
        .custom-file-input {
            cursor: pointer;
            /* height: 42px; */
            margin-bottom: 18px;
            height: 36px;
            max-width: clamp(172px,11.094vw,213px);
        }
        .custom-file-input:before {
            padding: 9px 0;
            width:0;
        }
        .text {
            font-size: clamp(12px,0.833vw,16px);

        }
        .error-message-multiple {
            position: absolute;
            top: 11px;
            left: 227px;
        }
   }
   .material-and-Condition {
    display: flex;
    /* gap: 80px; */
   }
   .loan-detail-wrapper {
    display: grid;
    align-items: flex-end;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr auto;
    gap: clamp(30px,2.083vw,40px);
    > button {
        height: clamp(27px,1.875vw,36px);
        width: clamp(80px,5.417vw,104px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: clamp(10px,0.729vw,14px);
        background: #FFFFFF;
        border: 1px solid #303030;
        border-radius: clamp(27px,1.875vw,36px);
        gap: 5px;
        > svg {
            width: clamp(11px,0.781vw,15px);
            height: clamp(11px,0.781vw,15px);
        }
        &.add-more {
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            border-color: transparent;
            color: #fff;
        }
    }
   }
   .comment-section{
        grid-template-columns: 5fr;
        gap: clamp(15px,2.083vw,40px);
        textarea{
            outline: none;
        }
    }
   .business-name-wrapper {
    display: flex;
    gap: min(5.313vw, 102px);
    align-items: flex-end;
    margin-bottom: 15px;
    > .app-input-text {
        width: 100%;
        max-width: 896px;
    }
    .equipment-requirements-wrapper {
        max-width: 630px;
        width: 100%;
        .requirements-checkbox {
            display: flex;
    justify-content: space-between;
        }
    }
    .uploadPhoto {
        > div {
            max-width: 204px;
            > span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    }
    .clone-outer-wrapper {
        display: flex;
        align-items: center;
        gap: 15px;
    }
    .clone-order-wrapper {
        display: flex;
        align-items: center;
        gap: clamp(8px,0.521vw,10px);
        background: rgba(216, 216, 216, 0.4);
            border: 0.5px solid #D8D8D8;
            border-radius: 4px;
            padding-right: clamp(8px,0.521vw,10px);
            margin: clamp(5px,0.469vw,9px) 0 clamp(15px,1.042vw,20px);
        .checkbox-field  {
            min-height: clamp(30px,2.083vw,40px);
            padding: 0 clamp(5px,0.469vw,9px);
            display: flex;
            align-items: center;
            .checkbox-container {
                margin: 5px 0;
                color: #979797;
                font-size: clamp(10px,0.729vw,14px);
                padding-left: clamp(21px,1.302vw,25px);
                .checkmark {
                    padding-top: 3px;
                    height: clamp(14px,0.885vw,17px);
                    width: clamp(14px,0.885vw,17px);
                  
                }
            }
        }
    }
    > div {
        display: flex;
        gap: clamp(20px, 6.25vw, 120px);
        > div {
            flex: 1;
            min-width: 860px;
            :nth-child(2) {
                max-width: 655px;
                min-width: auto;
            }
    }
    }
    .sec-label {
        font-size: clamp(12px,0.833vw,16px);
        /* line-height: 19px; */
        letter-spacing: 0.005em;
        color: #000;
        font-family: "latobold";
        margin-bottom: 15px;
    }
    .label-heading {
        font-weight: 700;
        font-size: clamp(14px,0.833vw,16px);
        line-height: normal;
        letter-spacing: 0.005em;
        color: #005586;
        margin-bottom: clamp(16px,1.146vw,22px);
    }    
    .rec-close-icon-style{
        width: 10px;
        height: 11px;
        margin-bottom: 12px;
        margin-left: 10px;
        cursor: pointer;
    }
    .rec-button-selected-style{
        cursor: pointer;
        margin-top: 18px;
        height: 36px;
        width: 172px;
        border-radius: 4px;
        background: linear-gradient(180deg,#61b01f 0,#27911b);
        border: none;
        color: #fff;
        font-size: 13px;
    }
    .rec-button-unselected-style{
        cursor: pointer;
        margin-top: 18px;
        height: 36px;
        width: 172px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #111111;
        color: #000;
        font-size: 13px;
    }
    @media (max-width: 1626px) {
        > div {
            > div {
                min-width: 730px;
            }
        }
    }
    @media (max-width: 1478px) {
        > div {
            gap: 40px;
            > div {
                min-width: auto;
            }
        }
    }
    @media (max-width: 1277px) {
        > div {
            > div {
                min-width: 565px;
            }
        }
    }

    .star {
    color: red;
    }
    
`
export const UploadSpec = styled.div`    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-start;
    /* max-width: 204px; */
    span {
        white-space: normal;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        text-overflow: ellipsis;
        padding-top: 5px;
        cursor: pointer;

    }
    img {
      margin-right: 5px;
      cursor: pointer;

    }
`

export const RecurringModalWrapper = styled.div`
    .modal-body{
        padding: 0px !important;
    }
    .header-wrapper{
        display: flex;
        justify-content: space-between;
        padding: 18px;
        background: #0000000d;
        border-radius: 5px 5px 0 0;
        h6{
            font-weight: bold;
            font-size: 18px;
        }
        img{
            height: 20px;
            width: 20px;
            cursor: pointer;
        }
    }
    .modal-description{
        display: flex;
        justify-content: center;
        padding: 25px;
    }
    .content-title{
        font-weight: bold;
        padding-left: 20px;
    }
    .recc-content{
        padding: 20px;
        .content-header{
            display: flex;
            p{
                padding: 10px 30px 10px 30px;
                cursor: pointer;
            }
            .header-border-style{
                border: 1px solid #00000033;
                box-shadow: -8px -8px 10px -10px #00000026;
                border-radius: 5px 5px 0px 0px;
                margin-bottom: -1px;
                background: #fff;
                border-bottom: 1px solid #fff;
                color: #005586;
            }
        }
        .recc-options{
            border: 1px solid #00000033;
            box-shadow: 0px 4px 10px 0px #00000026;
            border-radius: 5px;
            .recc-option-weekly{
                padding: 20px;
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
                }

                input[type="number"] {
                -moz-appearance: textfield;
                }
                .week-input{
                    border: none;
                    border-bottom: 1px solid #E0E0E0;
                    width: 40px;
                    outline: none;
                    padding: 0 10px;
                }
                .week-options-style{
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 20px;
                    line-height: 40px;
                    label{
                        margin-right: 20px;
                        position: relative;
                        bottom: 11px;
                    }
                    input{
                        margin-right: 7px;
                        height: 18px;
                        width: 18px;
                        accent-color: #005586;
                    }
                }
            }
            .recc-option-monthly{
                padding: 20px;
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
                }

                input[type="number"] {
                -moz-appearance: textfield;
                }
                .month-input{
                    border: none;
                    border-bottom: 1px solid #E0E0E0;
                    width: 40px;
                    outline: none;
                    padding: 0 10px;
                }
                .filler-words-span{
                    display: flex;
                    align-items: center;
                }
                .react-select__control{
                    min-height: 32px;
                }
            }
        }
    }
    .date-wrapper{
        padding: 20px;
        display: flex;
        .MuiInputBase-input{
            font-size: 13px;
            width: 100px;
        }
    }
    .button-wrapper{
        padding: 20px;
        text-align: center;
        button{
            margin: 5px;
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            padding: 8px 10px 8px 10px;
            border-radius: 4px;
            border: none;
            width: 80px;
        }
    }
    .MuiFormHelperText-root.Mui-error{
        position: relative;
        bottom: 0;
    }
`